import React, {useContext} from 'react';
import InvoicePrintView from "./invoice-print-view";
import {Store} from "../../../app/stores/store-root";



class InvoicePrintContainer extends React.PureComponent {
    static contextType = Store;
    render() {
        return <div>
            <InvoicePrintView order={this.context.Orders.CurrentOrder}/>
        </div>
    }
}

export default InvoicePrintContainer;